import typeCheck from 'common/util/typeCheck';
import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_SHOWING_REMOVED_FROM_AGENT_TOUR,
} from 'client/analytics/eventList';

import {
  SR_API_ACTION_DELETE_SHOWING,
} from 'api/actionTypes';

export default async function deleteShowing({ state, apiClient }, {
  tourId,
  listingId,
  tourCancelReason,
  onSuccess,
}) {
  typeCheck('onSuccess::Maybe Function', onSuccess);
  await apiClient.postWithState({
    action: SR_API_ACTION_DELETE_SHOWING,
    queryId: `${tourId}-${listingId}`,
    state: state,
    payload: {
      tourId,
      listingId,
      tourCancelReason,
    },
    onSuccess(tours) {
      analytics.track(ANALYTICS_EVENT_SHOWING_REMOVED_FROM_AGENT_TOUR, {
        tourId: tourId,
        listingId: listingId,
        showingCancelReason: tourCancelReason,
      });
      state.set(['tours'], tours);
      state.commit();
      if (onSuccess) {
        onSuccess();
      }
    },
  });
}
